module.exports = __webpack_public_path__ + "static/media/Gradient_Circle.64627029.svg";